import Http from './http';
/**
 * {"name":"Bruno Sousa","cpf":"065.422.422-66","email":"brunosousa@gmail.com","password":"123456","supermarket":{"id":"vvjUNdnDrKWZS42Blti5emlTY6o2","razaoSocial":"Projetos Codesilva","nomeFantasia":"Supermercado codesilva"}}
 */
export const createNewPicker = (pickerData) => Http.post('createPicker', pickerData);